import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function SeleccionLote() {
    const navigate = useNavigate();
    const { manzanaId } = useParams();
    const [lotes, setLotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLotes = async () => {
            try {
				const response = await fetch(`${API_BASE_URL}/api/lotes/manzanas/${manzanaId}`);
                //const response = await fetch(`http://192.168.0.3:3001/api/lotes/manzanas/${manzanaId}`);
                if (!response.ok) {
                    throw new Error('Error al obtener los lotes');
                }
                const data = await response.json();
                setLotes(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchLotes();
    }, [manzanaId]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl text-gray-600">Cargando lotes...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 p-4 rounded-lg">
                <div className="text-red-700">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">Seleccione un Lote</h2>
                <button 
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Volver
                </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {lotes.map(lote => (
                    <div 
                        key={lote.id_lote}
                        //onClick={() => navigate(`/venta/${lote.id_lote}`)}
						onClick={() => navigate(`/buscar-cliente/${lote.id_lote}`)}
                        className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-all"
                    >
                        <h3 className="text-lg font-semibold text-gray-800">
                            Lote {lote.numero_lote}
                        </h3>
                        
                        <div className="mt-4 space-y-2">
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Dimensión:</span>
                                <span className="font-medium">{lote.dimension_lote} m²</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Imp. Entrada:</span>
                                <span className="font-medium">₲ {Number(lote.importe_entrada_lote).toLocaleString()}</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Cant. Meses:</span>
                                <span className="font-medium">{lote.cantidad_meses_lote}</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Cuota:</span>
                                <span className="font-medium">₲ {Number(lote.cuota_lote).toLocaleString()}</span>
                            </div>
                        </div>
                        
                        <div className="mt-4">
                            <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                                {lote.estado_lote}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}